<template>
  <div class="backgournd-box" id="service">
    <b-container >
      <b-row>
        <b-col class="m-landing-h1-center">
          <h1 class="m-landing-h1">Manage your customer data</h1>
          <p class="m-landing-h1-brief">Improve and enrich the information in your customer database. Simply choose a service and load your file. Go refill your coffee and your updated file already may be waiting for you!
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h3  class="m-landing-h3">Enhance your data</h3>
          <p>Append our data to your current book of business so you can segment and target customers better. Send more relevant messaging and offers, for better ROI.</p>
          <div class="service-box">
            <a v-for="menu in menus" class="menu-box"
               v-if="menu.type === 'enhance'"
               :href="$store.getters['config/link'](menu.link)"
               v-m-ua-event="['landing', 'dataservice', menu.title]">
              <h3 class="service-btn">
                <div class="icon-box">
                  <icon :name="menu.icon" class="service-icon" scale="2"/>
                </div>
                {{menu.title}}
              </h3>
              <!--<b-btn>Get Started</b-btn>-->
              <div class="menu-content-box">
                <p>{{menu.benefit}}</p>
              </div>
            </a>
          </div>
        </b-col>
      </b-row>
      <b-row style="margin-top: 24px">
        <b-col>
          <h3  class="m-landing-h3">Clean & verify your data</h3>
          <p>De-duplicate records, correct undeliverable addresses and screen for privacy... all to save you time and money.</p>
          <div class="service-box">
            <a v-for="menu in menus" class="menu-box"
               v-if="menu.type === 'clean'"
               :href="$store.getters['config/link'](menu.link)"
               v-m-ua-event="['landing', 'dataservice', menu.title]">
              <h3 class="service-btn">
                <div class="icon-box">
                  <icon :name="menu.icon" class="service-icon" scale="2"/>
                </div>
                {{menu.title}}
              </h3>
              <!--<b-btn>Get Started</b-btn>-->
              <div class="menu-content-box">
                <p>{{menu.benefit}}</p>
              </div>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        menus: [
          {
            title: 'Append Demographics or Psychographics',
            benefit: 'Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.',
            link: 'enhanceList',
            icon: 'share-alt',
            type: 'enhance'
          }, {
            title: 'Clean your Database',
            benefit: 'Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.',
            link: 'cleanList',
            icon: 'eraser',
            type: 'clean'
          }, {
            title: 'Append Email Addresses',
            benefit: 'Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.',
            link: 'emailAppend',
            icon: 'envelope-open-o',
            type: 'enhance'
          }, {
            title: 'Verify Email Addresses',
            benefit: 'Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.',
            link: 'emailVerification',
            icon: 'envelope-o',
            type: 'clean'
          }, {
            title: 'Append Phone Numbers',
            benefit: 'Provides an additional and low cost channel to communicate with customers.',
            link: 'phoneAppend',
            icon: 'mobile',
            type: 'enhance'
          }, {
            title: 'Reverse Phone Append',
            benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
            link: 'phoneReverse',
            icon: 'phone',
            type: 'enhance'
          }, {
            title: 'Verify phone numbers',
            benefit: 'Saves you time calling bad numbers and improves your connection rate with customers.',
            link: 'phoneVerification',
            icon: 'volume-control-phone',
            type: 'clean'
          }
        ]
      }
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">

  .backgournd-box {
    margin-top: 16px;
    padding-top: 64px;
    padding-bottom: 64px;
    min-height: 240px;
    background: #fff;
  }
  .order-btn {
    width: 150px;
    margin-bottom: 10px;
    display: block;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    margin-right: 24px;
  }
  .menu-head-box {
    background-color: $color-primary;
    height: 108px;
    padding: 16px;
  }
  .menu-head-box h4 {
    color: #fff
  }
  .menu-content-box {
    padding: 0 0;
    height: 80px;
    text-align: left;
    margin-left: 40px;
  }

  .menu-box {
    width: calc(25% - 32px);
    margin-right: 16px;
    margin-left: 16px;
    cursor: pointer;
    border-radius: 8px;
    text-align: center;
    padding: 16px;
    padding-top: 32px;
    height: 280px;
    display: block;
  }
  .menu-box:hover {
    text-decoration: none;
  }

  .menu-box:hover {
    transform: scale(1.1);
    background-color: $color-background;
  }

  .service-icon {
    /*margin-top: 16px;*/
    color: $color-primary;
  }

  .icon-box {
    margin-right: 16px;
  }
  .service-btn {
    display: flex;
    font-size: 16px;
    justify-content: left;
    text-align: left;
  }

  .service-box {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MSectionService.vue